import { Dimensions } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET, MD_DEVICE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;



export default MediaQueryStyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    height: "100%"
  },
  dateSelect:
  {
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  accordionCollapse: {
    marginLeft: 20,
    borderRight: "1px solid",
    borderRightColor: "5d6d7e",
    fontWeight: 'bold',
    // color:'#ffffff',
    fontSize: 14,
    flex: 1
  },
  accordionCollapseNumber: {
    marginLeft: 20,
    borderRight: "1px solid",
    borderRightColor: "5d6d7e",
    fontWeight: 'bold',
    fontSize: 14,
    // color:'#ffffff',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  accordionMainNumber: {
    marginLeft: 20,
    borderRight: "1px solid",
    borderRightColor: "5d6d7e",
    fontSize: 12,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    paddingBottom: 5
  },
  accordionMain: {
    marginLeft: 20,
    borderRight: "1px solid",
    borderRightColor: "5d6d7e",
    fontSize: 12,
    flex: 1,
    paddingBottom: 5
  },
  accordionMainLast: {
    marginLeft: 20,
    fontSize: 12,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    paddingBottom: 5
  },

  accordionCollapseLast: {
    marginLeft: 20,
    fontSize: 14,
    // color:'#ffffff',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },


  dateSelectorView: {
    border: "solid",
    borderWidth: "1px",
    borderRadius: "5px",
    width: "45%",
    maxHeight: "40px",
    borderColor: '#a7a8aa',
    margin: "10px",
    float: "right",
    marginTop: "20px"
  },

  dateRangeSelector: {
    paddingHorizontal: 5,
    minHeight: 35,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#a7a8aa',
    margin: 10,
  },
  date: {
    color: 'white'
  },
  dateWrapperParent: {

  },
  dateWrapper: {

  },
  calendarContainer: {
    border: "solid",
    borderWidth: 1,
    borderRadius: 5,
    borderColor: '#a7a8aa',
    marginRight: 27,
    alignSelf: 'flex-end',
    width: '80%',
  }
}, {
    [MQ_TABLET]: {
      mainWrapper: {
        width: WINDOW_WIDTH * 0.92,
        flexDirection: 'row',
        alignSelf: 'center',
        // marginTop:30,
        paddingBottom: 30,
        justifyContent: 'center',
      },
      leftWrapper: {
        width: WINDOW_WIDTH * 0.50,
        minHeight: WINDOW_HEIGHT * 0.7,
        alignSelf: 'flex-start',
        flexDirection: 'row',
        paddingRight: 20,
      },
      rightWrapper: {
        width: WINDOW_WIDTH * 0.42,
      },
      subItems: {
      },
      groupSelection: {
        borderTopWidth: 0,
      },
      tabletView: {
        flex: 1,
      },

    },
    [MD_DEVICE]: {
      dateWrapper: {
        flex: 0.6
      }
    }
  });
